export default __webpack_public_path__ + "media/images/messagecards/blue-095af35ec6125e59bce39a6e88a4de33.jpg";